<mat-card appearance="raised">
  <mat-card-header class="card-header">
    <mat-card-title>Statements</mat-card-title>
    <button *ngIf="canEditAccountDocumentsGeneration"
            mat-icon-button
            routerLink="statements"
            aria-label="Edit">
      <mat-icon>edit</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content class="mat-card-content-lg no-bottom-padding">
    <ifc-horizontal-list [items]="listItems">
      <ng-template horizontalListCustomTemplate="aligatorDataValue">
        <ifb-account-alligator-data-icon-chip class="aligator-chip"
                                              [alligatorDataSync]="data?.alligatorMatch">
        </ifb-account-alligator-data-icon-chip>
      </ng-template>
    </ifc-horizontal-list>
  </mat-card-content>
</mat-card>
